customElements.get("quick-add-modal") ||
  customElements.define(
    "quick-add-modal",
    class extends ModalDialog {
      constructor() {
        super(), (this.modalContent = this.querySelector('[id^="QuickAddInfo-"]'));
      }
      hide(e = !1) {
        const t = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        t && t.setActiveElement(this.openedBy),
          (this.modalContent.innerHTML = ""),
          e && (this.openedBy = null),
          super.hide();
      }
      show(e) {
        super.show(e),
          e.setAttribute("aria-disabled", !0),
          e.classList.add("loading"),
          e.querySelector(".loading-overlay__spinner").classList.remove("hidden"),
          fetch(e.getAttribute("data-product-url"))
            .then((e) => e.text())
            .then((t) => {
              const r = new DOMParser().parseFromString(t, "text/html");
              (this.productElement = r.querySelector('section[id^="MainProduct-"]')),
                this.preventDuplicatedIDs(),
                this.removeDOMElements(),
                this.setInnerHTML(this.modalContent, this.productElement.innerHTML),
                window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
                window.ProductModel && window.ProductModel.loadShopifyXR(),
                this.removeGalleryListSemantic(),
                this.updateImageSizes(),
                this.preventVariantURLSwitching();
            })
            .finally(() => {
              e.removeAttribute("aria-disabled"),
                e.classList.remove("loading"),
                e.querySelector(".loading-overlay__spinner").classList.add("hidden");
            });
      }
      setInnerHTML(e, t) {
        (e.innerHTML = t),
          e.querySelectorAll("script").forEach((e) => {
            const t = document.createElement("script");
            Array.from(e.attributes).forEach((e) => {
              t.setAttribute(e.name, e.value);
            }),
              t.appendChild(document.createTextNode(e.innerHTML)),
              e.parentNode.replaceChild(t, e);
          });
      }
      preventVariantURLSwitching() {
        if (!this.modalContent) return;
        const e = this.modalContent.querySelector("variant-radios,variant-selects");
        e && e.setAttribute("data-update-url", "false");
        e.setAttribute("variants-cart", "false");
      }
      removeDOMElements() {
        if (!this.productElement) return;
        const e = this.productElement.querySelector("pickup-availability");
        e && e.remove();
        const t = this.productElement.querySelector("product-modal");
        t && t.remove();
        const r = this.productElement.querySelectorAll("modal-dialog");
        r && r.forEach((e) => e.remove());
      }
      preventDuplicatedIDs() {
        if (!this.productElement) return;
        const e = this.productElement.dataset.section;
        (this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(e, `quickadd-${e}`)),
          this.productElement.querySelectorAll("variant-selects, variant-radios, product-info").forEach((t) => {
            t.dataset.originalSection = e;
          });
      }
      removeGalleryListSemantic() {
        if (!this.modalContent) return;
        const e = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        e &&
          (e.setAttribute("role", "presentation"),
          e.querySelectorAll('[id^="Slide-"]').forEach((e) => e.setAttribute("role", "presentation")));
      }
      updateImageSizes() {
        if (!this.modalContent) return;
        const e = this.modalContent.querySelector(".product");
        if (!e.classList.contains("product--columns")) return;
        const t = e.querySelectorAll(".product__media img");
        if (!t.length) return;
        let r = "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
        e.classList.contains("product--medium")
          ? (r = r.replace("715px", "605px"))
          : e.classList.contains("product--small") && (r = r.replace("715px", "495px")),
          t.forEach((e) => e.setAttribute("sizes", r));
      }
    }
  );

class ProductQuickAddElement extends HTMLElement {
  constructor() {
    super();

    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");

    this.productJson = JSON.parse(this.getAttribute("data-product-json"));
    this.productVariantsJson = JSON.parse(this.getAttribute("data-product-variants-json"));
    this.productJson.variants = this.productVariantsJson;
    this.variantOrderDefault = (this.getAttribute("data-variant-order-default") || "")
      .split(",")
      .map((value) => value.trim().toUpperCase())
      .filter(Boolean);
    this.productOptions = [];

    for (let i = 0; i < this.productJson.options.length; i++) {
      const option = this.productJson.options[i];
      this.productOptions.push({
        name: option.toLowerCase(),
        position: i + 1,
      });
    }

    this.card = this.closest(".product-card-wrapper");
    this.colorSelector = this.card ? this.card.querySelector("product-card-color-selector") : null;
    if (this.colorSelector) {
      this.colorSelector.addEventListener("colorChanged", this.handleColorChange.bind(this));
    }
    this.cardInner = this.closest(".card__inner");
    this.optionsWrapper = this.querySelector(".quick-add__options_wrapper");

    this.openButton = this.nextElementSibling;
    if(this.openButton) this.openButton.addEventListener("click", this.open.bind(this));

    // this.submitButton = this.querySelector(".quick-add__submit");
    // this.submitButton.addEventListener("click", this.addSelectedVariant.bind(this));

    // Statsig price group settings
    this.hasPriceGroup = this.getAttribute("data-price-groups") == "" ? true : false;
    this.productHandle = this.getAttribute("data-product-handle");
    this.priceGroup = null;

    if (this.hasPriceGroup) {
      document.addEventListener(`${this.productHandle}-price-group-loaded`, ({ detail }) => {
        if (this.priceGroup) return;
        this.priceGroup = { groupId: detail?.groupId, priceAdjustment: detail?.priceAdjustment };
      })
    }
  }

  shouldUseCustomVariantOrder(option) {
    return option.name === "tamanho";
  }

  sortOptionValues(option) {
    if (!this.shouldUseCustomVariantOrder(option) || !this.variantOrderDefault.length) {
      return option.values;
    }

    const orderedValues = [];
    const unorderedValues = [];

    this.variantOrderDefault.forEach((configuredValue) => {
      option.values.forEach((value) => {
        if (configuredValue === value.trim().toUpperCase() && !orderedValues.includes(value)) {
          orderedValues.push(value);
        }
      });
    });

    option.values.forEach((value) => {
      const normalizedValue = value.trim().toUpperCase();
      if (!this.variantOrderDefault.includes(normalizedValue)) {
        unorderedValues.push(value);
      }
    });

    return orderedValues.concat(unorderedValues);
  }

  handleColorChange(event) {
    this.close();
  }

  buildVariantSelector() {
    // this.submitButton.setAttribute("disabled", true);

    if (this.colorSelector) {
      const currentColor = this.colorSelector.currentColor;

      // Monta as opções de acordo com a cor selecionada
      const optionsValues = [[], [], []];
      for (let i = 0; i < this.productJson.variants.length; i++) {
        const variant = this.productJson.variants[i];
        const variantTitleHandle = slugify(variant.title);

        if (variantTitleHandle.includes(currentColor)) {
          if (variant.option1 && !optionsValues[0].includes(variant.option1)) {
            optionsValues[0].push(variant.option1);
          }
          if (variant.option2 && !optionsValues[1].includes(variant.option2)) {
            optionsValues[1].push(variant.option2);
          }
          if (variant.option3 && !optionsValues[2].includes(variant.option3)) {
            optionsValues[2].push(variant.option3);
          }
        }
      }

      // Adiciona os valores das opções no objeto
      this.productOptions.forEach((option, index) => {
        option["values"] = optionsValues[index];
      });

      // Monta o seletor de opções
      this.optionsWrapper.innerHTML = "";
      this.productOptions.forEach((option) => {
        if (option.name === "color" || option.name === "cor") return;

        const optionWrapper = document.createElement("div");
        optionWrapper.classList.add("quick-add__option");

        const optionWrapperValues = document.createElement("div");
        optionWrapperValues.classList.add("quick-add__option__values");

        this.sortOptionValues(option).forEach((value) => {
          const optionLabel = document.createElement("label");
          optionLabel.classList.add("quick-add__option__value");
          optionLabel.setAttribute("for", `${this.id}--${value}`);

          const optionInput = document.createElement("input");
          if(optionInput){
            optionInput.setAttribute("type", "radio");
            optionInput.setAttribute("name", value);
            optionInput.setAttribute("id", `${this.id}--${value}`);
            optionInput.setAttribute("value", value);
            optionInput.setAttribute("data-option-position", option.position);
            optionLabel.appendChild(optionInput);
            optionInput.addEventListener("change", this.handleVariantSelect.bind(this));
          }

          const optionSpan = document.createElement("span");
          optionSpan.classList.add("quick-add__option__value__label");
          optionSpan.innerText = value;
          optionLabel.appendChild(optionSpan);

          optionWrapperValues.appendChild(optionLabel);
        });

        if (optionWrapperValues.children.length <= 2) {
          optionWrapperValues.classList.add("quick-add__option__values--double");
        }

        optionWrapper.appendChild(optionWrapperValues);
        this.optionsWrapper.appendChild(optionWrapper);
      });

      this.setOptionsAvailability(2);
    }
  }

  setOptionsAvailability(optionPosition) {
    if (optionPosition > this.productOptions.length) return;

    const selectedOptions = [];
    for (let i = 0; i < optionPosition - 1; i++) {
      const option = this.productOptions[i];
      if (option.name === "color" || option.name === "cor") {
        selectedOptions.push(this.colorSelector.currentColor);
      } else {
        const selectedOption = this.querySelector(`input[data-option-position="${option.position}"]:checked`);
        if (selectedOption) {
          selectedOptions.push(slugify(selectedOption.value));
        }
      }
    }
    const selectedOptionsString = selectedOptions.join("-");

    const availableByValue = {};
    for (let i = 0; i < this.productJson.variants.length; i++) {
      const variant = this.productJson.variants[i];
      const variantTitleHandle = slugify(variant.title);

      if (variantTitleHandle.includes(selectedOptionsString)) {
        availableByValue[variant[`option${optionPosition}`]] =
          availableByValue[variant[`option${optionPosition}`]] || variant.available;
      }
    }

    // Marcar opções não disponíveis
    const positionOptions = this.querySelectorAll(`input[data-option-position="${optionPosition}"]`);
    positionOptions.forEach((option) => {
      if (!availableByValue[option.value]) {
        option.setAttribute("disabled", true);
        option.closest("label").classList.add("quick-add__option__value--unavailable");

        option.checked = false;
        option.closest("label").classList.remove("quick-add__option__value--selected");
      } else {
        option.removeAttribute("disabled");
        option.closest("label").classList.remove("quick-add__option__value--unavailable");
      }
    });
  }

  handleVariantSelect(event) {
    const selectedInput = event.target;
    const selectedPosition = parseInt(selectedInput.getAttribute("data-option-position"));

    const optionInputs = this.querySelectorAll(`input[data-option-position="${selectedPosition}"]`);
    for (let i = 0; i < optionInputs.length; i++) {
      const input = optionInputs[i];
      if (input !== selectedInput) {
        input.checked = false;
        input.closest("label").classList.remove("quick-add__option__value--selected");
      } else {
        input.checked = true;
        input.closest("label").classList.add("quick-add__option__value--selected");
      }
    }

    if (selectedPosition < 3) {
      this.setOptionsAvailability(selectedPosition + 1);
    }

    this.handleAddProduct();
  }

  handleAddProduct() {
    const selectedOptions = [];
    for (let i = 0; i < this.productOptions.length; i++) {
      const option = this.productOptions[i];
      if (option.name === "color" || option.name === "cor") {
        selectedOptions.push(this.colorSelector.currentColor);
      } else {
        const selectedOption = this.querySelector(`input[data-option-position="${option.position}"]:checked`);
        if (selectedOption) {
          selectedOptions.push(selectedOption.value);
        }
      }
    }

    if (selectedOptions.length === this.productOptions.length) {
      this.close();
      this.addSelectedVariant();
      return true;
    } else {
      return false;
    }
  }

  getSelectedVariant() {
    return this.productJson.variants.filter((variant) => {
      const option1 = slugify(variant.option1) === this.colorSelector.currentColor;
      const option2Input = this.querySelector(`input[data-option-position="2"]:checked`);
      const option2 = !option2Input || variant.option2 === option2Input.value;
      const option3Input = this.querySelector(`input[data-option-position="3"]:checked`);
      const option3 = !option3Input || variant.option3 === option3Input.value;
      return option1 && option2 && option3;
    });
  }

  fnv32a(str, is64 = false) {
    let FNV1_32A_INIT = 0x811c9dc5;
    let hval = FNV1_32A_INIT;
    for (var i = 0; i < str.length; ++i) {
      hval ^= str.charCodeAt(i);
      hval += (hval << 1) + (hval << 4) + (hval << 7) + (hval << 8) + (hval << 24);
    }
    const result = ("0000000" + (hval >>> 0).toString(16)).substr(-8);
    if (!is64) return this.fnv32a(result + str + Math.random(0, 1000), true);
    return result;
  }

  addSelectedVariant() {
    const selectedVariant = this.getSelectedVariant();
    if (selectedVariant.length === 1) {
      const variant = selectedVariant[0];
      const variantId = variant.id;
      const variantCompareAtPrice = variant.compare_at_price;
      const quantity = 1;
      const config = fetchConfig("javascript");
      const properties = {
        _quick_add: true,
        // _key: this.fnv32a(new Date().getTime().toString() + Math.random(0, 1000)),
        _compare_at_price: (variantCompareAtPrice / 100).toFixed(2)
      }

      if (this.priceGroup) {
        properties["_price_group"] = this.priceGroup?.groupId;
        properties["_adjustment"] = this.priceGroup?.priceAdjustment;
      }

      const items = [
        {
          id: variantId,
          quantity: quantity,
          properties,
        },
      ];
      config.body = JSON.stringify({
        items,
        sections: "cart-drawer,cart-icon-bubble",
      });
      config.headers["site-placement"] = "quick-add";

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((data) => {
          this.close();

          if (data.status) {
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (data.items && data.items.length > 0) {
            this.handleCartUpdated(data.items, data.sections);
            fetchCartAndDispatch('quick-add', 'add');
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }

  handleCartUpdated(items, sections) {
    if (!this.cart) return;

    items.forEach((item) => {
      this.cart.renderContents({
        ...item,
        sections,
      });
    });

    document.getElementById("CartDrawer-Form").style.display = "block";
  }

  open() {
    if (!this.cardInner) return;
    this.cardInner.classList.toggle("quick-add-open");

    const productAdded = this.handleAddProduct();
    if (productAdded) return;
    this.buildVariantSelector();
  }

  close() {
    if (!this.cardInner) return;
    this.cardInner.classList.remove("quick-add-open");
    setTimeout(() => {
      this.optionsWrapper.innerHTML = "";
    }, 500);
  }
}

if (!customElements.get("product-quick-add")) {
  customElements.define("product-quick-add", ProductQuickAddElement);
}
